import { Component, OnInit, HostListener, Renderer2 } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { ScreenSizeService } from './shared/service/screen-size.service';
import { CompanyService } from './pages/company-detail/service/company.service';
import { LocalStorageService } from './shared/service/local-storage.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    companyID:any;
    constructor(private primengConfig: PrimeNGConfig, private _companyService:CompanyService, private _localStorage:LocalStorageService, private screenSizeService: ScreenSizeService, private router: Router, private renderer: Renderer2) {
      this.screenSizeService.checkViewportWidth();
     }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
      this.screenSizeService.checkViewportWidth();
    }

    ngOnInit() {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          if (event.url.startsWith('/qr-access')) {
            this.renderer.addClass(document.body, 'qr-access-page');
          } else {
            this.renderer.removeClass(document.body, 'qr-access-page');
          }
        }
      });
        this.primengConfig.ripple = true;
        this.getCompany();
    }
	    getCompany(){
	        this.companyID = this._localStorage.getValue("company_id");
	        // Public QR visitors do not have a company session. Calling
	        // company/null/ can return 401 and trigger the global logout flow.
	        if (!this.companyID || this.router.url.startsWith('/qr-access')) {
	          return;
	        }
	        this.getCompanyDetail( this.companyID);
	      }
      getCompanyDetail(id:any){
        this._companyService.getCompanyDetail(id).subscribe((res:any)=>{
          console.log("this is the detail response", res)
          const response = res.result;
          const croppedImageSave = response.logo_path;
          this._localStorage.setValue('company_logo', croppedImageSave);
          this._localStorage.setValue('promo_enabled', res?.result?.promo_enabled);
          this._localStorage.setValue('ai_enabled', res?.result?.ai_enabled);
        })
      }
}
